module.exports = __webpack_public_path__ + "static/media/08-_DSC7984.194f8293.jpg";